import BaseService from "../../services/BaseService";
import ProjectService from "../../services/ProjectService";
import UserService from "../../services/UserService"; // Assuming you have a similar service for users
import router from "../../router";

export default {
  state: {
    projects: [],
    users: [], // Added users state
    activeProjectDialog: null,
    activeProject: {},
    activeProjectId: null,
    projectsLoaded: false,
  },
  getters: {
    projects: (state) => state.projects,
    users: (state) => state.users, // Added users getter
    activeProjectDialog: (state) => state.activeProjectDialog,
    activeProject: (state) => state.activeProject,
    activeProjectId: (state) => state.activeProjectId,
    projectsLoaded: (state) => state.projectsLoaded,
  },
  mutations: {
    SET_PROJECTS(state, projects) {
      state.projects = projects;
    },
    SET_USERS(state, users) {
      // Added users mutation
      state.users = users;
    },
    SET_PROJECTS_DIALOG(state, value) {
      state.activeProjectDialog = value;
    },
    SET_ACTIVE_PROJECT(state, project) {
      state.activeProject = project;
    },
    SET_ACTIVE_PROJECT_ID(state, project) {
      state.activeProjectId = project;
    },
    SET_PROJECTS_LOADED(state) {
      state.projectsLoaded = true;
    },
  },
  actions: {
    setActiveProject({ state, commit }, id) {
      let filtered = state.projects.filter((item) => {
        return item.project_id === id;
      });

      filtered.length && commit("SET_ACTIVE_PROJECT", filtered[0]);
      commit("SET_ACTIVE_PROJECT_ID", id);
    },
    async loadProjects({ state, commit }, force = false) {
      if (force || !state.projects.length) {
        let result = await ProjectService.index();
        if (result.status === BaseService.STATUS_200) {
          commit("SET_PROJECTS", result.data);
          commit("SET_PROJECTS_DIALOG", result.data.length);
          commit("SET_PROJECTS_LOADED");

          if (!state.projects.length) {
            if (router.currentRoute.name !== "projects-dashboard") {
              router.push({ name: "projects-dashboard" });
            }
          }
        }
      }
    },
    createCompanyProject({ dispatch }, data) {
      return ProjectService.createCompanyProject(data).then((result) => {
        if (result.status === BaseService.STATUS_200) {
          dispatch("loadProjects", true);
          dispatch("loadAccounts", true);
        }
      });
    },
    createFamilyProject({ dispatch }, data) {
      return ProjectService.createFamilyProject(data).then((result) => {
        if (result.status === BaseService.STATUS_200) {
          dispatch("loadProjects", true);
          dispatch("loadAccounts", true);
        }
      });
    },
    updateCompanyProject({ dispatch }, params) {
      return ProjectService.updateCompanyProject(params.id, params.data).then(
        (result) => {
          if (result.status === BaseService.STATUS_200) {
            dispatch("loadProjects", true);
          }
        }
      );
    },
    updateFamilyProject({ dispatch }, params) {
      return ProjectService.updateFamilyProject(params.id, params.data).then(
        (result) => {
          if (result.status === BaseService.STATUS_200) {
            dispatch("loadProjects", true);
          }
        }
      );
    },
    deleteCompanyProject({ dispatch }, id) {
      return ProjectService.deleteCompanyProject(id).then((result) => {
        if (result.status === BaseService.STATUS_200) {
          dispatch("loadProjects", true);
        }
      });
    },
    deleteFamilyProject({ dispatch }, id) {
      return ProjectService.deleteFamilyProject(id).then((result) => {
        if (result.status === BaseService.STATUS_200) {
          dispatch("loadProjects", true);
        }
      });
    },
    addUserToProject({ dispatch }, data) {
      return ProjectService.addUserToProject(data).then((result) => {
        if (result.status === BaseService.STATUS_200) {
          dispatch("loadProjects", true);
        }
      });
    },
    deleteUserFromProject({ dispatch }, data) {
      return ProjectService.deleteUserFromProject(data.membershipId).then(
        (result) => {
          if (result.status === BaseService.STATUS_200) {
            dispatch("loadProjects", true);
          }
        }
      );
    },
    async loadUsers({ state, commit }, force = false) {
      if (force || !state.users.length) {
        let result = await UserService.index(); // Assuming UserService has an index method
        if (result.status === BaseService.STATUS_200) {
          commit("SET_USERS", result.data);
        }
      }
    },
  },
};
